import { render } from "./produccion-ia.vue?vue&type=template&id=7bff70ec"
import script from "./produccion-ia.vue?vue&type=script&lang=js"
export * from "./produccion-ia.vue?vue&type=script&lang=js"

import "./produccion-ia.vue?vue&type=style&index=0&id=7bff70ec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__